module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Ken Shufeldt\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("KEN SHUFELDT was born in Kansas and raised in the West Texas Panhandle. He served in the US Navy for a number of years before leaving to begin a career in computer programming, where he specializes in law enforcement system software and 911 dispatch software. The author of "), _c('I', [_vm._v("Genesis")]), _vm._v(","), _c('I', [_vm._v(" Tribulations")]), _vm._v(", and "), _c('I', [_vm._v("Rebellion")]), _vm._v(", he lives and works in Amarillo, Texas, and is currently at work on his next novel.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/VKpMVI/tc-custom/9781429939706.jpg?1734579069106",
      "alt": "This image is the cover for the book Genesis"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Genesis\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("When an old manuscript holding the secrets of human extinction is found, two children with strange powers must set out to save the human race.")]), _c('br'), _c('br'), _vm._v(" A strange 100,000-year-old manuscript in a long-forgotten language has been the basis for all the major religions throughout history. Lost and buried in a sarcophagus during the Second Iraq War, it holds the secrets of human birth—and extinction."), _c('br'), _c('br'), _vm._v(" Two children are born with transcendent talents and preternatural powers beyond human comprehension. Only they understand the magnitude of the disaster to come. They are the last, best hope for human survival."), _c('br'), _c('br'), _vm._v(" Indelibly bonded, these enigmatic youths—this brave new Adam and Eve—are thrown against their wills into a headlong race to save the world."), _c('br'), _c('br'), _c('b', [_vm._v("“"), _c('i', [_vm._v("Genesis ")]), _vm._v("reads like "), _c('i', [_vm._v("Left Behind")]), _vm._v(" on steroids!” —"), _c('i', [_vm._v("Douglas Preston, New York Times–")]), _vm._v("bestselling author of "), _c('i', [_vm._v("Blasphemy")])])]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Tom Doherty Associates\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0